import PermissionIssue from "../../components/permissionIssue";
import CategoryComponent from "../../components/CategoryManagement";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../store/store";
import { LinearProgress } from "@mui/material";

const CategoryManagementPage = () => {
  const [isAllow, setIsAllow] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const { userData } = useAppSelector((state) => state.authReducer);

  useEffect(() => {
    if (userData) {
      setIsAllow(
        JSON.parse(
          userData.permission !== null ? userData.permission : "[]"
        ).includes("8")
      );
      setIsReady(true);
    }
  }, [userData]);

  return isReady ? (
    <>
      {userData.group === "admin" ? (
        <CategoryComponent />
      ) : (
        <PermissionIssue />
      )}
    </>
  ) : (
    <LinearProgress color="secondary" />
  );
};

export default CategoryManagementPage;
